import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';

import Favorite from './favorite';

const enhance = compose(
  withNamespaces(['common']),
);
export default enhance(Favorite);
